import React from 'react';
import {FileText, Wallet, ArrowLeftRight, Info} from 'lucide-react';

// Financial data is deliberately not inferred from the identity directory,
// a partial document page, registration status, or customer payments.
export default function SupplierMetrics({individual=false}) {
    const metrics=[
        [individual?'إجمالي فواتير المورد':'إجمالي فواتير الموردين','قبل السداد والمرتجعات',FileText],
        [individual?'المدفوع للمورد':'المدفوع للموردين','السداد النقدي والبنكي',Wallet],
        ['المقاصات','تسويات غير نقدية',ArrowLeftRight],
        [individual?'المتبقي للمورد':'المتبقي للموردين','بعد السداد والمرتجعات والمقاصات',FileText],
    ];
    return <>
        <section className="supplier-metrics" aria-label={individual?'ملخص حساب المورد':'ملخص حسابات الموردين'}>
            {metrics.map(([label,hint,Icon],index)=><div className={`supplier-metric${index===0?' supplier-metric-primary':''}`} key={label}>
                <span><span>{label}</span><Icon size={20} aria-hidden="true"/></span>
                <strong>غير متاح</strong><small>{hint}</small>
            </div>)}
        </section>
        <p className="supplier-source-note"><Info size={18} aria-hidden="true"/><span>لم يُربط قارئ ذمم الموردين المعتمد بعد. مشتريات الزيارات والمصروفات المستقلة متاحة من مصادرها، ولا تمثل وحدها إجمالي الفواتير أو الرصيد الحالي.</span></p>
    </>;
}
